
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.b1816521588 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b1909941236 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b1582628792 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b547492401 = numberParserFn([{",":".",".":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.a1428865472 = pluralGeneratorFn(function(n
) {
  var s = String(n).split('.'), v0 = !s[1];
  return (n == 1 && v0) ? 'one' : 'other';
});
Globalize.a1838331891 = messageFormatterFn((function(  ) {
  return function(d) { return "Reisen: Urlaub, günstige Flüge, Tickets und Flugpreise"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1068157029 = messageFormatterFn((function(  ) {
  return function(d) { return "Punkte eingelöst"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a145507208 = messageFormatterFn((function(  ) {
  return function(d) { return "Punkte werden nicht eingelöst"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a2040494156 = messageFormatterFn((function(  ) {
  return function(d) { return "Dialogfeld schließen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b158815857 = messageFormatterFn((function(  ) {
  return function(d) { return "Reiseziel"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b168505013 = messageFormatterFn((function(  ) {
  return function(d) { return "Anreise"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a637392348 = messageFormatterFn((function(  ) {
  return function(d) { return "Abreise"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1116581943 = messageFormatterFn((function(  ) {
  return function(d) { return "Datum"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1158986867 = messageFormatterFn((function(  ) {
  return function(d) { return "Reisende"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a732529049 = messageFormatterFn((function(  ) {
  return function(d) { return "Suchen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a677288227 = messageFormatterFn((function(  ) {
  return function(d) { return "Weitere Informationen zu " + d["0"]; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1269234240 = messageFormatterFn((function(  ) {
  return function(d) { return "Website von " + d["0"] + " wird in einer neuen Registerkarte geöffnet; geh zurück zur ursprünglichen Registerkarte, um auf unserer Website fortzufahren"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1364759579 = messageFormatterFn((function(  ) {
  return function(d) { return "Suchergebnisse"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b651518060 = messageFormatterFn((function(  ) {
  return function(d) { return "Wähle ein Reiseziel aus"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a807900882 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte wähle ein Anreisedatum"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1056304083 = messageFormatterFn((function(  ) {
  return function(d) { return "Wähle Daten für deine Reise"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b589964973 = messageFormatterFn((function(  ) {
  return function(d) { return "Das Abreisedatum muss nach dem Anreisedatum liegen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b325698277 = messageFormatterFn((function(  ) {
  return function(d) { return "Das Abreisedatum muss innerhalb von 28 Tagen nach dem Anreisedatum liegen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b653827999 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte wähle ein Abreisedatum"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b142647473 = messageFormatterFn((function(  ) {
  return function(d) { return "Wähle die Anzahl der Reisenden aus"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1047068328 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte gib das Alter des reisenden Kindes an"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b2010266328 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte gib das Alter der reisenden Kinder an."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1819416646 = messageFormatterFn((function(  ) {
  return function(d) { return "Die Daten des Aufenthalts in der Unterkunft müssen innerhalb des Reisezeitraums liegen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1303256875 = messageFormatterFn((function(  ) {
  return function(d) { return "Auswählen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1933986563 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["de-BE"], { zero: function() { return number(d["0"]) + " Zimmer";}, one: function() { return number(d["0"]) + " Zimmer";}, two: function() { return number(d["0"]) + " Zimmer";}, few: function() { return number(d["0"]) + " Zimmer";}, many: function() { return number(d["0"]) + " Zimmer";}, other: function() { return number(d["0"]) + " Zimmer";} }) + ", " + plural(d["1"], 0, pluralFuncs["de-BE"], { zero: function() { return number(d["1"]) + " Gäste";}, one: function() { return number(d["1"]) + " Gast";}, two: function() { return number(d["1"]) + " Gäste";}, few: function() { return number(d["1"]) + " Gäste";}, many: function() { return number(d["1"]) + " Gäste";}, other: function() { return number(d["1"]) + " Gäste";} }); }
})(messageFormat.number, messageFormat.plural, {"de-BE": Globalize("de-BE").pluralGenerator()}), Globalize("de-BE").pluralGenerator({}));
Globalize.b907338541 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["de-BE"], { zero: function() { return number(d["1"]) + " Gäste";}, one: function() { return number(d["1"]) + " Gast";}, two: function() { return number(d["1"]) + " Gäste";}, few: function() { return number(d["1"]) + " Gäste";}, many: function() { return number(d["1"]) + " Gäste";}, other: function() { return number(d["1"]) + " Gäste";} }); }
})(messageFormat.number, messageFormat.plural, {"de-BE": Globalize("de-BE").pluralGenerator()}), Globalize("de-BE").pluralGenerator({}));
Globalize.a1198904427 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["de-BE"], { zero: function() { return number(d["1"]) + " Reisende";}, one: function() { return number(d["1"]) + " Reisender";}, two: function() { return number(d["1"]) + " Reisende";}, few: function() { return number(d["1"]) + " Reisende";}, many: function() { return number(d["1"]) + " Reisende";}, other: function() { return number(d["1"]) + " Reisende";} }) + ", Haustiere"; }
})(messageFormat.number, messageFormat.plural, {"de-BE": Globalize("de-BE").pluralGenerator()}), Globalize("de-BE").pluralGenerator({}));
Globalize.a2102373130 = messageFormatterFn((function(  ) {
  return function(d) { return "Reisende"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1476959358 = messageFormatterFn((function(  ) {
  return function(d) { return "Zimmer " + d["0"] + " hinzugefügt. Bearbeite unten die Angaben zu den Gästen."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1344472866 = messageFormatterFn((function(  ) {
  return function(d) { return "Zimmer entfernt. Bearbeite unten die Angaben zu den Gästen in Zimmer " + d["0"] + "."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1153580290 = messageFormatterFn((function(  ) {
  return function(d) { return "Abbrechen, Gästeauswahl schließen, ohne Änderungen zu speichern. Oder bearbeite unten die Angaben zu den Gästen."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a567979326 = messageFormatterFn((function(  ) {
  return function(d) { return "Übernehmen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b2042946490 = messageFormatterFn((function(  ) {
  return function(d) { return "Änderungen speichern und Gästeauswahl schließen."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1761241574 = messageFormatterFn((function(  ) {
  return function(d) { return "Zimmer hinzufügen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1473387589 = messageFormatterFn((function(  ) {
  return function(d) { return "Zimmer entfernen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1427846077 = messageFormatterFn((function(  ) {
  return function(d) { return "Zimmer " + d["0"] + " von " + d["1"] + " entfernen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1785352001 = messageFormatterFn((function(  ) {
  return function(d) { return "Alter von Kind " + d["0"]; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1376749289 = messageFormatterFn((function(  ) {
  return function(d) { return "Zimmer " + d["0"]; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b743888568 = messageFormatterFn((function(  ) {
  return function(d) { return "Zimmer " + d["0"] + " von " + d["1"]; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1904402230 = messageFormatterFn((function(  ) {
  return function(d) { return "Kind " + d["0"] + ", Alter auf " + d["1"] + " aktualisiert."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1089384868 = messageFormatterFn((function(  ) {
  return function(d) { return "Unter 1"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a2048630894 = messageFormatterFn((function(  ) {
  return function(d) { return "Kinder"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1180514021 = messageFormatterFn((function(  ) {
  return function(d) { return "(Alter 0-17)"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1462668316 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["de-BE"], { zero: function() { return number(d["0"]) + " Erwachsene";}, one: function() { return number(d["0"]) + " Erwachsener";}, two: function() { return number(d["0"]) + " Erwachsene";}, few: function() { return number(d["0"]) + " Erwachsene";}, many: function() { return number(d["0"]) + " Erwachsene";}, other: function() { return number(d["0"]) + " Erwachsene";} }); }
})(messageFormat.number, messageFormat.plural, {"de-BE": Globalize("de-BE").pluralGenerator()}), Globalize("de-BE").pluralGenerator({}));
Globalize.b2053795678 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["de-BE"], { zero: function() { return number(d["0"]) + " Kinder";}, one: function() { return number(d["0"]) + " Kind";}, two: function() { return number(d["0"]) + " Kinder";}, few: function() { return number(d["0"]) + " Kinder";}, many: function() { return number(d["0"]) + " Kinder";}, other: function() { return number(d["0"]) + " Kinder";} }); }
})(messageFormat.number, messageFormat.plural, {"de-BE": Globalize("de-BE").pluralGenerator()}), Globalize("de-BE").pluralGenerator({}));
Globalize.a1057701108 = messageFormatterFn((function(  ) {
  return function(d) { return "Erwachsene"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a2127862000 = messageFormatterFn((function(  ) {
  return function(d) { return "Anzahl der Kinder in Zimmer " + d["0"] + " verringern"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1330408950 = messageFormatterFn((function(  ) {
  return function(d) { return "Anzahl der Erwachsenen in Zimmer " + d["0"] + " verringern"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1400887604 = messageFormatterFn((function(  ) {
  return function(d) { return "Anzahl der Kinder in Zimmer " + d["0"] + " erhöhen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1292254510 = messageFormatterFn((function(  ) {
  return function(d) { return "Anzahl der Erwachsenen in Zimmer " + d["0"] + " erhöhen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1329131454 = messageFormatterFn((function(  ) {
  return function(d) { return "Haustiere"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b85084706 = messageFormatterFn((function(  ) {
  return function(d) { return "Haustiere inbegriffen?"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1049702702 = messageFormatterFn((function(  ) {
  return function(d) { return "Ja"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a2133382020 = messageFormatterFn((function(  ) {
  return function(d) { return "Nein"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a647376334 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " wurde zu deinen Listen hinzugefügt"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b2069897480 = messageFormatterFn((function(  ) {
  return function(d) { return "Wird in einem neuen Fenster geöffnet"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a361382883 = messageFormatterFn((function(  ) {
  return function(d) { return "Gästebewertungen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1674651835 = messageFormatterFn((function(  ) {
  return function(d) { return "Abbrechen und zu den Hoteldetails zurückkehren"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1208870861 = messageFormatterFn((function(  ) {
  return function(d) { return "Verfügbarkeit prüfen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b57244578 = messageFormatterFn((function(  ) {
  return function(d) { return "Verfügbarkeit prüfen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1424803628 = messageFormatterFn((function(  ) {
  return function(d) { return "Suche ändern"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b299394639 = messageFormatterFn((function(  ) {
  return function(d) { return "Wähle ein späteres Anreisedatum"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a755038733 = messageFormatterFn((function(  ) {
  return function(d) { return "Wähle ein früheres Anreisedatum"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b236048306 = messageFormatterFn((function(  ) {
  return function(d) { return "Wähle ein späteres Abreisedatum"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a818385066 = messageFormatterFn((function(  ) {
  return function(d) { return "Wähle ein früheres Abreisedatum"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a2024725660 = messageFormatterFn((function(  ) {
  return function(d) { return "Alter Preis: " + d["0"]; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a949742802 = messageFormatterFn((function(  ) {
  return function(d) { return "Der Preis beträgt " + d["0"]; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1643526665 = messageFormatterFn((function(  ) {
  return function(d) { return "Der neue Preis beträgt " + d["0"]; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1492177541 = messageFormatterFn((function(  ) {
  return function(d) { return "Der Preis betrug " + d["0"] + ", jetzt beträgt er " + d["1"]; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b363850174 = messageFormatterFn((function(  ) {
  return function(d) { return "pro Nacht"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a322995374 = messageFormatterFn((function(  ) {
  return function(d) { return "Abbrechen und zu den Hoteldetails zurückkehren"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a598272646 = messageFormatterFn((function(  ) {
  return function(d) { return "Weitere Details"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b330731632 = messageFormatterFn((function(  ) {
  return function(d) { return "Schließen und zu den Hoteldetails zurückkehren"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1334119750 = messageFormatterFn((function(  ) {
  return function(d) { return "Das hat nicht geklappt."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b848853004 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte führe eine neue Suche durch."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1616544132 = messageFormatterFn((function(  ) {
  return function(d) { return "Optionen anzeigen und reservieren"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b87759 = messageFormatterFn((function(  ) {
  return function(d) { return "Vielleicht gefällt dir auch"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a455328100 = messageFormatterFn((function(  ) {
  return function(d) { return "Filter entfernen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b675922964 = messageFormatterFn((function(  ) {
  return function(d) { return "Sortieren & filtern"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a718848882 = messageFormatterFn((function(  ) {
  return function(d) { return "Fertig"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1469849351 = messageFormatterFn((function(  ) {
  return function(d) { return "Löschen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1776936048 = messageFormatterFn((function(  ) {
  return function(d) { return "Klicke auf Übernehmen oder navigiere zurück, um die Filter zu schließen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1919850002 = messageFormatterFn((function(  ) {
  return function(d) { return "Mindestpreis"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1040692388 = messageFormatterFn((function(  ) {
  return function(d) { return "Höchstpreis"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1791738199 = messageFormatterFn((function(  ) {
  return function(d) { return "Sternebewertung"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b8529242 = messageFormatterFn((function(  ) {
  return function(d) { return "Sortieren nach"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b850883143 = messageFormatterFn((function(  ) {
  return function(d) { return "Filtern nach"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a243765369 = messageFormatterFn((function(  ) {
  return function(d) { return "Zurück zur Hotelsuche"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1536954223 = messageFormatterFn((function(  ) {
  return function(d) { return "Wir durchsuchen Tausende von Unterkünften"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b90059498 = messageFormatterFn((function(  ) {
  return function(d) { return "Wir durchsuchen Tausende von Reisepaketen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a327182686 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["de-BE"], { zero: function() { return number(d["0"]) + " Filter";}, one: function() { return number(d["0"]) + " Filter";}, two: function() { return number(d["0"]) + " Filter";}, few: function() { return number(d["0"]) + " Filter";}, many: function() { return number(d["0"]) + " Filter";}, other: function() { return number(d["0"]) + " Filter";} }) + " angewandt"; }
})(messageFormat.number, messageFormat.plural, {"de-BE": Globalize("de-BE").pluralGenerator()}), Globalize("de-BE").pluralGenerator({}));
Globalize.a668904286 = messageFormatterFn((function(  ) {
  return function(d) { return "Sortieren & filtern"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b264573010 = messageFormatterFn((function(  ) {
  return function(d) { return "Filter"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a359111679 = messageFormatterFn((function(  ) {
  return function(d) { return "Auf Karte anzeigen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1597571100 = messageFormatterFn((function(  ) {
  return function(d) { return "Die Ergebnisse werden geladen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1812083389 = messageFormatterFn((function(  ) {
  return function(d) { return "Die Ergebnisse wurden aktualisiert"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b389121523 = messageFormatterFn((function(  ) {
  return function(d) { return "Fehler beim Abrufen der Ergebnisse"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a86253881 = messageFormatterFn((function(  ) {
  return function(d) { return "Keine Ergebnisse"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1366440119 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels suchen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1181001286 = messageFormatterFn((function(  ) {
  return function(d) { return "Schließen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a976445583 = messageFormatterFn((function(  ) {
  return function(d) { return "Versuche es mit diesen Daten"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1721495 = messageFormatterFn((function(  ) {
  return function(d) { return "Mehr Daten anzeigen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b36099621 = messageFormatterFn((function(  ) {
  return function(d) { return "Weniger Daten anzeigen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1814897964 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotel-Suchergebnisse für " + d["0"]; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b860027272 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ": Suchergebnisse für Ferienunterkünfte"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a976760121 = messageFormatterFn((function(  ) {
  return function(d) { return "Ungültige Hotel-Suchergebnisse"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a376645257 = messageFormatterFn((function(  ) {
  return function(d) { return "Mehr anzeigen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a941487089 = messageFormatterFn((function(  ) {
  return function(d) { return "Leider konnten wir keine Ergebnisse finden.  Versuche es mit einer anderen Suchanfrage."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1100034427 = messageFormatterFn((function(  ) {
  return function(d) { return "Ausgewählter Filter"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1247005223 = messageFormatterFn((function(  ) {
  return function(d) { return "Ausgewählte Filter"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1825139495 = messageFormatterFn((function(  ) {
  return function(d) { return "Reiseziel nicht angegeben"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1251339725 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "–" + d["1"]; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a733937619 = messageFormatterFn((function(  ) {
  return function(d) { return "Alle Filter entfernen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1023707922 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["de-BE"], { zero: function() { return number(d["0"]) + " Gäste";}, one: function() { return number(d["0"]) + " Gast";}, two: function() { return number(d["0"]) + " Gäste";}, few: function() { return number(d["0"]) + " Gäste";}, many: function() { return number(d["0"]) + " Gäste";}, other: function() { return number(d["0"]) + " Gäste";} }); }
})(messageFormat.number, messageFormat.plural, {"de-BE": Globalize("de-BE").pluralGenerator()}), Globalize("de-BE").pluralGenerator({}));
Globalize.a412398506 = messageFormatterFn((function(  ) {
  return function(d) { return "Leider liegt bei uns gerade ein Problem vor"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a413667593 = messageFormatterFn((function(  ) {
  return function(d) { return "Erneut versuchen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a221682319 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " in deinen Listen speichern"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1675773947 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " aus deinen Listen entfernen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b482544173 = messageFormatterFn((function(  ) {
  return function(d) { return "Details deines nächsten Aufenthalts"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a145519300 = messageFormatterFn((function(  ) {
  return function(d) { return "In diesem Gebiet suchen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1100155630 = messageFormatterFn((function(  ) {
  return function(d) { return "Leider ist gerade etwas schiefgegangen. Bitte wiederhole deine Suche."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1948139641 = messageFormatterFn((function(  ) {
  return function(d) { return "Karte schließen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1957575743 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["de-BE"], { zero: function() { return number(d["0"]) + " Unterkünfte";}, one: function() { return number(d["0"]) + " Unterkunft";}, two: function() { return number(d["0"]) + " Unterkünfte";}, few: function() { return number(d["0"]) + " Unterkünfte";}, many: function() { return number(d["0"]) + " Unterkünfte";}, other: function() { return number(d["0"]) + " Unterkünfte";} }) + "\nab " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"de-BE": Globalize("de-BE").pluralGenerator()}), Globalize("de-BE").pluralGenerator({}));
Globalize.a712184472 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["de-BE"], { zero: function() { return number(d["0"]) + " Unterkünfte";}, one: function() { return number(d["0"]) + " Unterkunft";}, two: function() { return number(d["0"]) + " Unterkünfte";}, few: function() { return number(d["0"]) + " Unterkünfte";}, many: function() { return number(d["0"]) + " Unterkünfte";}, other: function() { return number(d["0"]) + " Unterkünfte";} }); }
})(messageFormat.number, messageFormat.plural, {"de-BE": Globalize("de-BE").pluralGenerator()}), Globalize("de-BE").pluralGenerator({}));
Globalize.a860157455 = messageFormatterFn((function(  ) {
  return function(d) { return "Mehr anzeigen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b89158878 = messageFormatterFn((function(  ) {
  return function(d) { return "Weniger anzeigen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a297534512 = messageFormatterFn((function(  ) {
  return function(d) { return "Das tut uns leid, bei uns ist gerade etwas schiefgegangen."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1493279876 = messageFormatterFn((function(  ) {
  return function(d) { return "Nächstes Element"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a477762304 = messageFormatterFn((function(  ) {
  return function(d) { return "Vorheriges Element"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1838128861 = messageFormatterFn((function(  ) {
  return function(d) { return "Zum Buchungsabschluss"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b623806652 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Deine Reise (" + plural(d["0"], 0, pluralFuncs["de-BE"], { zero: function() { return number(d["0"]) + " Zimmer";}, one: function() { return number(d["0"]) + " Zimmer";}, two: function() { return number(d["0"]) + " Zimmer";}, few: function() { return number(d["0"]) + " Zimmer";}, many: function() { return number(d["0"]) + " Zimmer";}, other: function() { return number(d["0"]) + " Zimmer";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"de-BE": Globalize("de-BE").pluralGenerator()}), Globalize("de-BE").pluralGenerator({}));
Globalize.b1363256557 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Deine Reise (" + plural(d["0"], 0, pluralFuncs["de-BE"], { zero: function() { return number(d["0"]) + " Aufenthalte";}, one: function() { return number(d["0"]) + " Aufenthalt";}, two: function() { return number(d["0"]) + " Aufenthalte";}, few: function() { return number(d["0"]) + " Aufenthalte";}, many: function() { return number(d["0"]) + " Aufenthalte";}, other: function() { return number(d["0"]) + " Aufenthalte";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"de-BE": Globalize("de-BE").pluralGenerator()}), Globalize("de-BE").pluralGenerator({}));
Globalize.a1333138441 = messageFormatterFn((function(  ) {
  return function(d) { return "Nächstes Zimmer auswählen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1254544602 = messageFormatterFn((function(  ) {
  return function(d) { return "Nicht mehr verfügbar"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1694823438 = messageFormatterFn((function(  ) {
  return function(d) { return "Eine oder mehrere Unterkünfte dieser Reise sind nicht mehr verfügbar. Möchtest du dennoch zum Buchungsabschluss gehen?"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1701801899 = messageFormatterFn((function(  ) {
  return function(d) { return "pro Zimmer"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1736161821 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["de-BE"], { zero: function() { return number(d["0"]) + " Gäste";}, one: function() { return number(d["0"]) + " Gast";}, two: function() { return number(d["0"]) + " Gäste";}, few: function() { return number(d["0"]) + " Gäste";}, many: function() { return number(d["0"]) + " Gäste";}, other: function() { return number(d["0"]) + " Gäste";} }); }
})(messageFormat.number, messageFormat.plural, {"de-BE": Globalize("de-BE").pluralGenerator()}), Globalize("de-BE").pluralGenerator({}));
Globalize.a891925121 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["de-BE"], { zero: function() { return number(d["0"]) + " Zimmer";}, one: function() { return number(d["0"]) + " Zimmer";}, two: function() { return number(d["0"]) + " Zimmer";}, few: function() { return number(d["0"]) + " Zimmer";}, many: function() { return number(d["0"]) + " Zimmer";}, other: function() { return number(d["0"]) + " Zimmer";} }) + ", " + plural(d["1"], 0, pluralFuncs["de-BE"], { zero: function() { return number(d["1"]) + " Gäste";}, one: function() { return number(d["1"]) + " Gast";}, two: function() { return number(d["1"]) + " Gäste";}, few: function() { return number(d["1"]) + " Gäste";}, many: function() { return number(d["1"]) + " Gäste";}, other: function() { return number(d["1"]) + " Gäste";} }); }
})(messageFormat.number, messageFormat.plural, {"de-BE": Globalize("de-BE").pluralGenerator()}), Globalize("de-BE").pluralGenerator({}));
Globalize.a1914594190 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "/Nacht"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1837709034 = messageFormatterFn((function(  ) {
  return function(d) { return "Zimmer ändern"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b422333110 = messageFormatterFn((function(  ) {
  return function(d) { return "Code in die Zwischenablage kopiert."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a719236643 = messageFormatterFn((function(  ) {
  return function(d) { return "Leider liegt bei uns gerade ein Problem vor."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a2097666268 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte wiederhole deine Suche."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b849006138 = messageFormatterFn((function(  ) {
  return function(d) { return "Erneut versuchen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1620234637 = messageFormatterFn((function(  ) {
  return function(d) { return "Mietwagenabholung und -rückgabe"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1508640682 = messageFormatterFn((function(  ) {
  return function(d) { return "Abholzeit"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b963163390 = messageFormatterFn((function(  ) {
  return function(d) { return "Rückgabezeit"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1706112351 = messageFormatterFn((function(  ) {
  return function(d) { return "Mietwagen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1248622734 = messageFormatterFn((function(  ) {
  return function(d) { return "Die Rückgabezeit muss mindestens zwei Stunden nach der Abholzeit liegen."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b159195718 = messageFormatterFn((function(  ) {
  return function(d) { return "00:00 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b159106345 = messageFormatterFn((function(  ) {
  return function(d) { return "00:30 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b158272197 = messageFormatterFn((function(  ) {
  return function(d) { return "01:00 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b158182824 = messageFormatterFn((function(  ) {
  return function(d) { return "01:30 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b157348676 = messageFormatterFn((function(  ) {
  return function(d) { return "02:00 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b157259303 = messageFormatterFn((function(  ) {
  return function(d) { return "02:30 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b156425155 = messageFormatterFn((function(  ) {
  return function(d) { return "03:00 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b156335782 = messageFormatterFn((function(  ) {
  return function(d) { return "03:30 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b155501634 = messageFormatterFn((function(  ) {
  return function(d) { return "04:00 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b155412261 = messageFormatterFn((function(  ) {
  return function(d) { return "04:30 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b154578113 = messageFormatterFn((function(  ) {
  return function(d) { return "05:00 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b154488740 = messageFormatterFn((function(  ) {
  return function(d) { return "05:30 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b153654592 = messageFormatterFn((function(  ) {
  return function(d) { return "06:00 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b153565219 = messageFormatterFn((function(  ) {
  return function(d) { return "06:30 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b152731071 = messageFormatterFn((function(  ) {
  return function(d) { return "07:00 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b152641698 = messageFormatterFn((function(  ) {
  return function(d) { return "07:30 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b151807550 = messageFormatterFn((function(  ) {
  return function(d) { return "08:00 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b151718177 = messageFormatterFn((function(  ) {
  return function(d) { return "08:30 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b150884029 = messageFormatterFn((function(  ) {
  return function(d) { return "09:00 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b150794656 = messageFormatterFn((function(  ) {
  return function(d) { return "09:30 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b130566567 = messageFormatterFn((function(  ) {
  return function(d) { return "10:00 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b130477194 = messageFormatterFn((function(  ) {
  return function(d) { return "10:30 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b129643046 = messageFormatterFn((function(  ) {
  return function(d) { return "11:00 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b129553673 = messageFormatterFn((function(  ) {
  return function(d) { return "11:30 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b128719525 = messageFormatterFn((function(  ) {
  return function(d) { return "12:00 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b128630152 = messageFormatterFn((function(  ) {
  return function(d) { return "12:30 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b127796004 = messageFormatterFn((function(  ) {
  return function(d) { return "13:00 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b127706631 = messageFormatterFn((function(  ) {
  return function(d) { return "13:30 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b126872483 = messageFormatterFn((function(  ) {
  return function(d) { return "14:00 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b126783110 = messageFormatterFn((function(  ) {
  return function(d) { return "14:30 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b125948962 = messageFormatterFn((function(  ) {
  return function(d) { return "15.00 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b125859589 = messageFormatterFn((function(  ) {
  return function(d) { return "15:30 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b125025441 = messageFormatterFn((function(  ) {
  return function(d) { return "16:00 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b124936068 = messageFormatterFn((function(  ) {
  return function(d) { return "16:30 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b124101920 = messageFormatterFn((function(  ) {
  return function(d) { return "17:00 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b124012547 = messageFormatterFn((function(  ) {
  return function(d) { return "17:30 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b123178399 = messageFormatterFn((function(  ) {
  return function(d) { return "18:00 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b123089026 = messageFormatterFn((function(  ) {
  return function(d) { return "18:30 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b122254878 = messageFormatterFn((function(  ) {
  return function(d) { return "19:00 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b122165505 = messageFormatterFn((function(  ) {
  return function(d) { return "19:30 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b101937416 = messageFormatterFn((function(  ) {
  return function(d) { return "20:00 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b101848043 = messageFormatterFn((function(  ) {
  return function(d) { return "20:30 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b101013895 = messageFormatterFn((function(  ) {
  return function(d) { return "21:00 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b100924522 = messageFormatterFn((function(  ) {
  return function(d) { return "21:30 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b100090374 = messageFormatterFn((function(  ) {
  return function(d) { return "22:00 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b100001001 = messageFormatterFn((function(  ) {
  return function(d) { return "22:30 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b99166853 = messageFormatterFn((function(  ) {
  return function(d) { return "23:00 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b99077480 = messageFormatterFn((function(  ) {
  return function(d) { return "23:30 Uhr"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a397514491 = messageFormatterFn((function(  ) {
  return function(d) { return "Nur Direktflüge"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b186795406 = messageFormatterFn((function(  ) {
  return function(d) { return "Bevorzugte Beförderungsklasse"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b520695882 = messageFormatterFn((function(  ) {
  return function(d) { return "Economy"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b919262575 = messageFormatterFn((function(  ) {
  return function(d) { return "Premium Economy"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1927250986 = messageFormatterFn((function(  ) {
  return function(d) { return "Business Class"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1372035794 = messageFormatterFn((function(  ) {
  return function(d) { return "First Class"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b431440983 = messageFormatterFn((function(  ) {
  return function(d) { return "Reisende"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1080852871 = messageFormatterFn((function(  ) {
  return function(d) { return "Für jedes Kleinkind auf dem Schoß muss mindestens eine Person im Alter von mindestens 6 Jahren mitreisen."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b534373964 = messageFormatterFn((function(  ) {
  return function(d) { return "Kleinkinder"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1446335293 = messageFormatterFn((function(  ) {
  return function(d) { return "(Alter 2–17 J.)"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1450803733 = messageFormatterFn((function(  ) {
  return function(d) { return "(Alter unter 2 J.)"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1984495133 = messageFormatterFn((function(  ) {
  return function(d) { return "Alter von Kleinkind " + d["0"]; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1418116127 = messageFormatterFn((function(  ) {
  return function(d) { return "Anzahl der Kleinkinder in Zimmer " + d["0"] + " verringern"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b705110277 = messageFormatterFn((function(  ) {
  return function(d) { return "Anzahl der Kleinkinder in Zimmer " + d["0"] + " erhöhen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1223603853 = messageFormatterFn((function(  ) {
  return function(d) { return "Kinder unter 2 Jahren müssen auf einem eigenen Sitzplatz oder auf dem Schoß sitzen."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1143322507 = messageFormatterFn((function(  ) {
  return function(d) { return "Auf dem Schoß"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1631568051 = messageFormatterFn((function(  ) {
  return function(d) { return "Auf einem Sitzplatz"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b670003086 = messageFormatterFn((function(  ) {
  return function(d) { return "Altersbeschränkungen der Fluglinie"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a259875394 = messageFormatterFn((function(  ) {
  return function(d) { return "Abreiseort"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1541644874 = messageFormatterFn((function(  ) {
  return function(d) { return "Hinreise"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1580547206 = messageFormatterFn((function(  ) {
  return function(d) { return "Rückreise"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a469991332 = messageFormatterFn((function(  ) {
  return function(d) { return "Wähle einen Abflughafen aus"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b655106878 = messageFormatterFn((function(  ) {
  return function(d) { return "Ich benötige nur während eines Teils meiner Reise eine Unterkunft"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1848302081 = messageFormatterFn((function(  ) {
  return function(d) { return "Leider ist bei uns etwas schiefgegangen. Bitte versuche es noch einmal."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b617403853 = messageFormatterFn((function(  ) {
  return function(d) { return "Wähle mindestens 1 weitere Unterkunft zum Vergleichen aus."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b357732944 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + "/" + plural(d["1"], 0, pluralFuncs["de-BE"], { zero: function() { return number(d["1"]) + " Unterkünften";}, one: function() { return number(d["1"]) + " Unterkunft";}, two: function() { return number(d["1"]) + " Unterkünften";}, few: function() { return number(d["1"]) + " Unterkünften";}, many: function() { return number(d["1"]) + " Unterkünften";}, other: function() { return number(d["1"]) + " Unterkünften";} }) + " ausgewählt"; }
})(messageFormat.number, messageFormat.plural, {"de-BE": Globalize("de-BE").pluralGenerator()}), Globalize("de-BE").pluralGenerator({}));
Globalize.a1785485932 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + "von " + plural(d["1"], 0, pluralFuncs["de-BE"], { zero: function() { return number(d["1"]) + " Unterkünften";}, one: function() { return number(d["1"]) + " Unterkunft";}, two: function() { return number(d["1"]) + " Unterkünften";}, few: function() { return number(d["1"]) + " Unterkünften";}, many: function() { return number(d["1"]) + " Unterkünften";}, other: function() { return number(d["1"]) + " Unterkünften";} }) + " zum Vergleich ausgewählt"; }
})(messageFormat.number, messageFormat.plural, {"de-BE": Globalize("de-BE").pluralGenerator()}), Globalize("de-BE").pluralGenerator({}));
Globalize.a1370017530 = messageFormatterFn((function(  ) {
  return function(d) { return "Vergleichen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a749483874 = messageFormatterFn((function(  ) {
  return function(d) { return "Ausgewählte Unterkünfte vergleichen."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b846113540 = messageFormatterFn((function(  ) {
  return function(d) { return "Vergleichen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1903091040 = messageFormatterFn((function(  ) {
  return function(d) { return "Ausgewählte Unterkünfte vergleichen."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1255983342 = messageFormatterFn((function(  ) {
  return function(d) { return "Anzeigen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b2040062390 = messageFormatterFn((function(  ) {
  return function(d) { return "Klicken, um die Unterkunft anzuzeigen."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1821346639 = messageFormatterFn((function(  ) {
  return function(d) { return "Entfernen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1221948405 = messageFormatterFn((function(  ) {
  return function(d) { return "Klicken, um die Unterkunft aus dem Vergleich zu entfernen."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1804786305 = messageFormatterFn((function(  ) {
  return function(d) { return "Unterkunftsvergleich schließen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b206546939 = messageFormatterFn((function(  ) {
  return function(d) { return "Unterkünfte vergleichen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1611350596 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kannst dir bis zu 5 Unterkünfte nebeneinander anzeigen lassen, um dir die Auswahl zu erleichtern. Klicke einfach auf „Vergleichen“, um loszulegen."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1587913792 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kannst dir bis zu 5 Unterkünfte nebeneinander anzeigen lassen, um dir die Auswahl zu erleichtern."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a415195880 = messageFormatterFn((function(  ) {
  return function(d) { return "Jetzt ausprobieren"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b14004324 = messageFormatterFn((function(  ) {
  return function(d) { return "Jetzt vergleichen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1290311536 = messageFormatterFn((function(  ) {
  return function(d) { return "Vergleich deaktivieren"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1344777236 = messageFormatterFn((function(  ) {
  return function(d) { return "Vielleicht später"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a786037841 = messageFormatterFn((function(  ) {
  return function(d) { return "Unterkünfte vergleichen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1658912342 = messageFormatterFn((function(  ) {
  return function(d) { return "Klicke in den Suchergebnissen einfach auf „Vergleichen“, um loszulegen."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a113150234 = messageFormatterFn((function(  ) {
  return function(d) { return "Sieh dir bis zu 5 Unterkünfte auf einmal an."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1061699267 = messageFormatterFn((function(  ) {
  return function(d) { return "Keine Verfügbarkeit am " + d["0"] + "."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1640709856 = messageFormatterFn((function(  ) {
  return function(d) { return "Check-out am " + d["0"] + " nicht möglich."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a634154639 = messageFormatterFn((function(  ) {
  return function(d) { return "Check-in am " + d["0"] + " nicht möglich."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a954492319 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1971594318 = messageFormatterFn((function(  ) {
  return function(d) { return "Passe deinen Aufenthalt an"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b149587986 = messageFormatterFn((function(  ) {
  return function(d) { return "Den Abschnitt „Passe deinen Aufenthalt an“ schließen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b664342912 = messageFormatterFn((function(  ) {
  return function(d) { return "Schließen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b335735800 = messageFormatterFn((function(  ) {
  return function(d) { return "Abbrechen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b2134927534 = messageFormatterFn((function(  ) {
  return function(d) { return "Verwerfen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a564113360 = messageFormatterFn((function(  ) {
  return function(d) { return "Fertig"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b725384302 = messageFormatterFn((function(  ) {
  return function(d) { return "Entfernen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a232831785 = messageFormatterFn((function(  ) {
  return function(d) { return "ausgewählt"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b895753852 = messageFormatterFn((function(  ) {
  return function(d) { return "werden geladen…"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b674101867 = messageFormatterFn((function(  ) {
  return function(d) { return "Löschen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1372760271 = messageFormatterFn((function(  ) {
  return function(d) { return "Wird in einem neuen Fenster geöffnet"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b15055703 = messageFormatterFn((function(  ) {
  return function(d) { return "Mehr anzeigen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a510261046 = messageFormatterFn((function(  ) {
  return function(d) { return "Weniger anzeigen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b985271186 = messageFormatterFn((function(  ) {
  return function(d) { return "Mehr anzeigen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a141085115 = messageFormatterFn((function(  ) {
  return function(d) { return "Weniger anzeigen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a2143708944 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ausgewählt. Wähle nun ein Abreisedatum aus."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1232134783 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ausgewählt. Wähle nun " + d["1"] + ", um diese Daten zu speichern und den Kalender zu schließen."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1904649445 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", ausgewählt. Aktuelles Anreisedatum."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b343382948 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", ausgewählt. Aktuelles Abreisedatum."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a270622130 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", deaktivierte Zelle"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b329260433 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", aktueller Monat"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b2114171306 = messageFormatterFn((function(  ) {
  return function(d) { return "Aktuell wird Folgendes angezeigt: " + d["0"] + " und " + d["1"]; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b448719078 = messageFormatterFn((function(  ) {
  return function(d) { return "Kalender geöffnet. Wähle aus den Tabellen unten einen Reisezeitraum aus."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1796904780 = messageFormatterFn((function(  ) {
  return function(d) { return "Abbrechen, Kalender schließen ohne Änderungen zu speichern. Oder wähle aus den Tabellen unten einen Reisezeitraum aus."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b2017216356 = messageFormatterFn((function(  ) {
  return function(d) { return "Ausgewählte Daten entfernen."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b971248465 = messageFormatterFn((function(  ) {
  return function(d) { return "Änderungen speichern und Kalender schließen."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1674906760 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["de-BE"], { zero: function() { return number(d["0"]) + " Nächte";}, 1: function() { return "Eine Nacht";}, two: function() { return number(d["0"]) + " Nächte";}, few: function() { return number(d["0"]) + " Nächte";}, many: function() { return number(d["0"]) + " Nächte";}, other: function() { return number(d["0"]) + " Nächte";} }); }
})(messageFormat.number, messageFormat.plural, {"de-BE": Globalize("de-BE").pluralGenerator()}), Globalize("de-BE").pluralGenerator({}));
Globalize.a1250022488 = messageFormatterFn((function(  ) {
  return function(d) { return "Anreise"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a2056480105 = messageFormatterFn((function(  ) {
  return function(d) { return "Abreise"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1806350902 = messageFormatterFn((function(  ) {
  return function(d) { return "Daten zurücksetzen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a572224585 = messageFormatterFn((function(  ) {
  return function(d) { return "Fertig"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1467812689 = messageFormatterFn((function(  ) {
  return function(d) { return "Suchen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1270076965 = messageFormatterFn((function(  ) {
  return function(d) { return "Bearbeite das Anreisedatum in den Tabellen unten."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b875879114 = messageFormatterFn((function(  ) {
  return function(d) { return "Bearbeite das Abreisedatum in den Tabellen unten."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b289440133 = messageFormatterFn((function(  ) {
  return function(d) { return "ausgewählt."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b92696110 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ausgewählt. Schließe den Kalender oder fahre fort, um das ausgewählte Datum zu ändern."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1401154394 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " bis " + d["1"] + " ausgewählt. Schließe den Kalender oder fahre fort, um die ausgewählten Daten zu ändern."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1167896544 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ausgewählt. " + d["1"] + ". Schließe den Kalender oder fahre fort, um das ausgewählte Datum zu ändern."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1074311640 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " bis " + d["1"] + " ausgewählt. " + d["2"] + ". Schließe den Kalender oder fahre fort, um die ausgewählten Daten zu ändern."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1169722943 = messageFormatterFn((function(  ) {
  return function(d) { return "Anreisedatum auswählen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b745140680 = messageFormatterFn((function(  ) {
  return function(d) { return "Abreisedatum auswählen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1651541593 = messageFormatterFn((function(  ) {
  return function(d) { return "leer"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b2040596283 = messageFormatterFn((function(  ) {
  return function(d) { return "Vorheriger Monat"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a795427241 = messageFormatterFn((function(  ) {
  return function(d) { return "Nächster Monat"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a291043526 = messageFormatterFn((function(  ) {
  return function(d) { return "Zur Schaltfläche " + d["0"] + " springen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a655451422 = messageFormatterFn((function(  ) {
  return function(d) { return "Vom " + d["0"] + " bis " + d["1"]; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1547002399 = messageFormatterFn((function(  ) {
  return function(d) { return "Die Daten wurden entfernt."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1754634578 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Es gibt " + plural(d["0"], 0, pluralFuncs["de-BE"], { zero: function() { return number(d["0"]) + " Ergebnisse";}, 1: function() { return "ein Ergebnis";}, two: function() { return number(d["0"]) + " Ergebnisse";}, few: function() { return number(d["0"]) + " Ergebnisse";}, many: function() { return number(d["0"]) + " Ergebnisse";}, other: function() { return number(d["0"]) + " Ergebnisse";} }); }
})(messageFormat.number, messageFormat.plural, {"de-BE": Globalize("de-BE").pluralGenerator()}), Globalize("de-BE").pluralGenerator({}));
Globalize.b1592921591 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Zu deiner Eingabe " + d["0"] + " " + plural(d["1"], 0, pluralFuncs["de-BE"], { zero: function() { return "sind " + number(d["1"]) + " Ergebnisse";}, one: function() { return "ist " + number(d["1"]) + " Ergebnis";}, two: function() { return "sind " + number(d["1"]) + " Ergebnisse";}, few: function() { return "sind " + number(d["1"]) + " Ergebnisse";}, many: function() { return "sind " + number(d["1"]) + " Ergebnisse";}, other: function() { return "sind " + number(d["1"]) + " Ergebnisse";} }) + " verfügbar. Navigiere mithilfe der Pfeiltasten oder einer Wischbewegung durch die Liste."; }
})(messageFormat.number, messageFormat.plural, {"de-BE": Globalize("de-BE").pluralGenerator()}), Globalize("de-BE").pluralGenerator({}));
Globalize.a124405931 = messageFormatterFn((function(  ) {
  return function(d) { return "Suche nach " + d["0"] + " ist geöffnet, bitte gib einen Suchbegriff ein."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1970030556 = messageFormatterFn((function(  ) {
  return function(d) { return "Deine Auswahl: " + d["0"] + "."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b331063167 = messageFormatterFn((function(  ) {
  return function(d) { return "Das Menü wurde geschlossen."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b951902649 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Die Suche für " + d["0"] + " ist geöffnet und zeigt derzeit " + plural(d["1"], 0, pluralFuncs["de-BE"], { 0: function() { return "keine Vorschläge";}, 1: function() { return "einen Vorschlag";}, two: function() { return number(d["1"]) + " Vorschläge";}, few: function() { return number(d["1"]) + " Vorschläge";}, many: function() { return number(d["1"]) + " Vorschläge";}, other: function() { return number(d["1"]) + " Vorschläge";} }) + " für " + d["2"] + " an. Bitte navigiere nach unten zur Liste mit den Vorschlägen."; }
})(messageFormat.number, messageFormat.plural, {"de-BE": Globalize("de-BE").pluralGenerator()}), Globalize("de-BE").pluralGenerator({}));
Globalize.b99092720 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Die Suche für " + d["0"] + " ist geöffnet und zeigt " + plural(d["1"], 0, pluralFuncs["de-BE"], { 0: function() { return "keine Vorschläge";}, 1: function() { return "einen Vorschlag";}, two: function() { return number(d["1"]) + " Vorschläge";}, few: function() { return number(d["1"]) + " Vorschläge";}, many: function() { return number(d["1"]) + " Vorschläge";}, other: function() { return number(d["1"]) + " Vorschläge";} }) + " an. Gib einen Suchbegriff ein oder navigiere zur Liste unten."; }
})(messageFormat.number, messageFormat.plural, {"de-BE": Globalize("de-BE").pluralGenerator()}), Globalize("de-BE").pluralGenerator({}));
Globalize.b935748620 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Die Suche für " + d["0"] + " ist geöffnet. Derzeitige Auswahl " + d["1"] + ". Es " + plural(d["1"], 0, pluralFuncs["de-BE"], { 0: function() { return "werden keine Vorschläge";}, 1: function() { return "wird ein Vorschlag";}, two: function() { return "werden " + number(d["1"]) + " Vorschläge";}, few: function() { return "werden " + number(d["1"]) + " Vorschläge";}, many: function() { return "werden " + number(d["1"]) + " Vorschläge";}, other: function() { return "werden " + number(d["1"]) + " Vorschläge";} }) + " für " + d["3"] + " angezeigt. Bitte navigiere nach unten zur Liste mit den Vorschlägen."; }
})(messageFormat.number, messageFormat.plural, {"de-BE": Globalize("de-BE").pluralGenerator()}), Globalize("de-BE").pluralGenerator({}));
Globalize.a50943090 = messageFormatterFn((function(  ) {
  return function(d) { return "Fertig"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a2129040535 = messageFormatterFn((function(  ) {
  return function(d) { return "Alle löschen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1581997636 = messageFormatterFn((function(  ) {
  return function(d) { return "Ausgewählt"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1000533495 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " wurde gelöscht."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1336617616 = messageFormatterFn((function(  ) {
  return function(d) { return "Alle ausgewählten Optionen wurden gelöscht."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a372364289 = messageFormatterFn((function(  ) {
  return function(d) { return "Du hast etwas in das Textfeld eingetippt. Bitte suche oder wähle aus den Vorschlägen unten eine Kategorie aus."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b98081566 = messageFormatterFn((function(  ) {
  return function(d) { return "Suche nach „" + d["0"] + "“"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b953296351 = messageFormatterFn((function(  ) {
  return function(d) { return "Keine Ergebnisse für „" + d["0"] + "“"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a677734071 = messageFormatterFn((function(  ) {
  return function(d) { return "Flughafen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b969896544 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotel"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a51058934 = messageFormatterFn((function(  ) {
  return function(d) { return "Sehenswürdigkeit"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1564880225 = messageFormatterFn((function(  ) {
  return function(d) { return "Nahe bei"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1013950108 = messageFormatterFn((function(  ) {
  return function(d) { return "Versuche doch einmal „" + d["0"] + "“"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b548282295 = messageFormatterFn((function(  ) {
  return function(d) { return "Region/Stadt"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1536864899 = messageFormatterFn((function(  ) {
  return function(d) { return "Flughafen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b899714811 = messageFormatterFn((function(  ) {
  return function(d) { return "Attraktion"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a496917612 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotel"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1920650092 = messageFormatterFn((function(  ) {
  return function(d) { return "Adresse"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1294245290 = messageFormatterFn((function(  ) {
  return function(d) { return "Bahnhof"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b974142023 = messageFormatterFn((function(  ) {
  return function(d) { return "Metrostation"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b725762147 = messageFormatterFn((function(  ) {
  return function(d) { return "Orte in der Nähe"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1523356660 = messageFormatterFn((function(  ) {
  return function(d) { return "Zuletzt gesucht"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a90790706 = messageFormatterFn((function(  ) {
  return function(d) { return "Danach suchten andere Nutzer"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1407890429 = messageFormatterFn((function(  ) {
  return function(d) { return "Angesagte Reiseziele entdecken"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a426638609 = messageFormatterFn((function(  ) {
  return function(d) { return "Beliebte Reiseziele"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1243249205 = messageFormatterFn((function(  ) {
  return function(d) { return "Angesagte Reiseziele"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a424772685 = messageFormatterFn((function(  ) {
  return function(d) { return "Dein Standort"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1870779978 = messageFormatterFn((function(  ) {
  return function(d) { return "Standortfreigabe deaktiviert"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1668959686 = messageFormatterFn((function(  ) {
  return function(d) { return "Leider können wir deinen Standort nicht ermitteln. Aktiviere bitte die standortbezogenen Dienste auf deinem Gerät oder gib einen Ort ein."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a500565662 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["de-BE"], { zero: function() { return number(d["0"]) + " Zimmer";}, one: function() { return number(d["0"]) + " Zimmer";}, two: function() { return number(d["0"]) + " Zimmer";}, few: function() { return number(d["0"]) + " Zimmer";}, many: function() { return number(d["0"]) + " Zimmer";}, other: function() { return number(d["0"]) + " Zimmer";} }) + ", " + plural(d["1"], 0, pluralFuncs["de-BE"], { zero: function() { return number(d["1"]) + " Gäste";}, one: function() { return number(d["1"]) + " Gast";}, two: function() { return number(d["1"]) + " Gäste";}, few: function() { return number(d["1"]) + " Gäste";}, many: function() { return number(d["1"]) + " Gäste";}, other: function() { return number(d["1"]) + " Gäste";} }); }
})(messageFormat.number, messageFormat.plural, {"de-BE": Globalize("de-BE").pluralGenerator()}), Globalize("de-BE").pluralGenerator({}));
Globalize.b688368392 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["de-BE"], { zero: function() { return number(d["0"]) + " Gäste";}, one: function() { return number(d["0"]) + " Gast";}, two: function() { return number(d["0"]) + " Gäste";}, few: function() { return number(d["0"]) + " Gäste";}, many: function() { return number(d["0"]) + " Gäste";}, other: function() { return number(d["0"]) + " Gäste";} }); }
})(messageFormat.number, messageFormat.plural, {"de-BE": Globalize("de-BE").pluralGenerator()}), Globalize("de-BE").pluralGenerator({}));
Globalize.a1073446892 = messageFormatterFn((function(  ) {
  return function(d) { return "Im Feld " + d["0"] + " steht jetzt " + d["1"] + ". Im Feld " + d["2"] + " steht jetzt " + d["3"] + "."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b2061217957 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " und " + d["1"] + " vertauschen."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1690384376 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort anzeigen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1376042237 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort verbergen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1240027254 = messageFormatterFn((function(  ) {
  return function(d) { return "Aktuell wird Folgendes angezeigt: " + d["0"]; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b212794273 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " von " + d["1"]; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b472423753 = messageFormatterFn((function(  ) {
  return function(d) { return "Bild " + d["0"] + " von " + d["1"] + ". " + d["2"]; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1311763700 = messageFormatterFn((function(  ) {
  return function(d) { return "Nächstes Bild öffnen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b508436496 = messageFormatterFn((function(  ) {
  return function(d) { return "Voriges Bild öffnen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1942742294 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["de-BE"], { zero: function() { return number(d["0"]) + " Bilder";}, 1: function() { return "Ein Bild";}, two: function() { return number(d["0"]) + " Bilder";}, few: function() { return number(d["0"]) + " Bilder";}, many: function() { return number(d["0"]) + " Bilder";}, other: function() { return number(d["0"]) + " Bilder";} }) + " öffnen"; }
})(messageFormat.number, messageFormat.plural, {"de-BE": Globalize("de-BE").pluralGenerator()}), Globalize("de-BE").pluralGenerator({}));
Globalize.a1667124683 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["de-BE"], { zero: function() { return number(d["0"]) + " Bilder";}, 1: function() { return "Ein Bild";}, two: function() { return number(d["0"]) + " Bilder";}, few: function() { return number(d["0"]) + " Bilder";}, many: function() { return number(d["0"]) + " Bilder";}, other: function() { return number(d["0"]) + " Bilder";} }) + " für " + d["1"] + " öffnen"; }
})(messageFormat.number, messageFormat.plural, {"de-BE": Globalize("de-BE").pluralGenerator()}), Globalize("de-BE").pluralGenerator({}));
Globalize.a1411730440 = messageFormatterFn((function(  ) {
  return function(d) { return "Abgeschlossen:"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b556984266 = messageFormatterFn((function(  ) {
  return function(d) { return "Aktuell:"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b790908188 = messageFormatterFn((function(  ) {
  return function(d) { return "Schritt " + d["0"] + " von " + d["1"]; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1209873848 = messageFormatterFn((function(  ) {
  return function(d) { return "Schritt " + d["0"] + " von " + d["1"] + ":"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a699140217 = messageFormatterFn((function(  ) {
  return function(d) { return "Bild " + d["0"] + " von " + d["1"] + ". " + d["2"]; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1323885770 = messageFormatterFn((function(  ) {
  return function(d) { return "Nächstes Bild"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a83107122 = messageFormatterFn((function(  ) {
  return function(d) { return "Vorheriges Bild"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b833606468 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", auf Vollbild vergrößern"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1283780440 = messageFormatterFn((function(  ) {
  return function(d) { return "Miniaturansicht " + d["0"] + ", auf Vollbild vergrößern"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1380226478 = messageFormatterFn((function(  ) {
  return function(d) { return "Aktuelle Seite"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1397070366 = messageFormatterFn((function(  ) {
  return function(d) { return "Mehr Breadcrumbs anzeigen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1359249250 = messageFormatterFn((function(  ) {
  return function(d) { return "Weniger Breadcrumbs anzeigen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b411464571 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " Prozent, Ladevorgang läuft."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1760521920 = messageFormatterFn((function(  ) {
  return function(d) { return "Ladevorgang läuft"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a240166128 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", " + d["1"]; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1081976135 = messageFormatterFn((function(  ) {
  return function(d) { return "Ein Fehler ist aufgetreten."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a474547947 = messageFormatterFn((function(  ) {
  return function(d) { return "Sieh dir dieses Video auf YouTube an oder aktiviere JavaScript, falls es in deinem Browser deaktiviert ist."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1071134189 = messageFormatterFn((function(  ) {
  return function(d) { return "Video abspielen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1905363421 = messageFormatterFn((function(  ) {
  return function(d) { return "Video anhalten"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a360976891 = messageFormatterFn((function(  ) {
  return function(d) { return "Video lädt"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b234632975 = messageFormatterFn((function(  ) {
  return function(d) { return "360-Grad-Bild"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b689186155 = messageFormatterFn((function(  ) {
  return function(d) { return "Dies ist eine 360-Grad-Aufnahme. Verwende die Steuerungstaste und die Pfeiltasten oder die Befehlstaste und die Pfeiltasten, um in ihr zu navigieren."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a892492798 = messageFormatterFn((function(  ) {
  return function(d) { return "Momentan wird folgendes Bild angezeigt: " + d["0"]; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1651311773 = messageFormatterFn((function(  ) {
  return function(d) { return "Nach links verschoben. Position: " + d["0"] + " Grad"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a796271900 = messageFormatterFn((function(  ) {
  return function(d) { return "Nach rechts verschoben. Position: " + d["0"] + " Grad"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1016518897 = messageFormatterFn((function(  ) {
  return function(d) { return "Nach oben verschoben."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1432014456 = messageFormatterFn((function(  ) {
  return function(d) { return "Nach unten verschoben."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1738978999 = messageFormatterFn((function(  ) {
  return function(d) { return "Du hast den obersten Bildrand erreicht."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1087092641 = messageFormatterFn((function(  ) {
  return function(d) { return "Du hast den untersten Bildrand erreicht."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1985037747 = messageFormatterFn((function(  ) {
  return function(d) { return "Alle Zeilen auswählen."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1600908178 = messageFormatterFn((function(  ) {
  return function(d) { return "Auswahl aller Zeilen aufheben."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1693723298 = messageFormatterFn((function(  ) {
  return function(d) { return "Spalte in absteigender Reihenfolge sortieren"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1668500924 = messageFormatterFn((function(  ) {
  return function(d) { return "Spalte in aufsteigender Reihenfolge sortieren"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a168396052 = messageFormatterFn((function(  ) {
  return function(d) { return "Die Einträge der Spalte werden jetzt in absteigender Reihenfolge angezeigt."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1940780268 = messageFormatterFn((function(  ) {
  return function(d) { return "Die Einträge der Spalte werden jetzt in aufsteigender Reihenfolge angezeigt."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1610274444 = messageFormatterFn((function(  ) {
  return function(d) { return "Zeile " + d["0"] + " erweitern."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1976924659 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Anzeige von " + d["0"] + " von " + plural(d["1"], 0, pluralFuncs["de-BE"], { zero: function() { return number(d["1"]) + " Elementen";}, one: function() { return number(d["1"]) + " Element";}, two: function() { return number(d["1"]) + " Elementen";}, few: function() { return number(d["1"]) + " Elementen";}, many: function() { return number(d["1"]) + " Elementen";}, other: function() { return number(d["1"]) + " Elementen";} }) + "."; }
})(messageFormat.number, messageFormat.plural, {"de-BE": Globalize("de-BE").pluralGenerator()}), Globalize("de-BE").pluralGenerator({}));
Globalize.b839276323 = messageFormatterFn((function(  ) {
  return function(d) { return "Derzeit werden die Monate " + d["0"] + " " + d["1"] + " und " + d["2"] + " " + d["3"] + " angezeigt."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1476867061 = messageFormatterFn((function(  ) {
  return function(d) { return "Derzeit wird der Monat " + d["0"] + " " + d["1"] + " angezeigt."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1280677696 = messageFormatterFn((function(  ) {
  return function(d) { return "Deine aktuellen Monate reichen von " + d["0"] + " " + d["1"] + " bis " + d["2"] + " " + d["3"] + "."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1846945403 = messageFormatterFn((function(  ) {
  return function(d) { return "Das Anreisedatum wurde gelöscht."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1828951822 = messageFormatterFn((function(  ) {
  return function(d) { return "Das Abreisedatum wurde gelöscht."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1280721043 = messageFormatterFn((function(  ) {
  return function(d) { return "Die Daten wurden gelöscht."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1438699896 = messageFormatterFn((function(  ) {
  return function(d) { return "Daten zurücksetzen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1248109800 = messageFormatterFn((function(  ) {
  return function(d) { return "Auswählen"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b883977141 = messageFormatterFn((function(  ) {
  return function(d) { return "Nächster Monat"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b428778613 = messageFormatterFn((function(  ) {
  return function(d) { return "Vorheriger Monat"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1862774607 = messageFormatterFn((function(  ) {
  return function(d) { return "Zur Schaltfläche Auswählen springen."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1608418916 = messageFormatterFn((function(  ) {
  return function(d) { return "Zur Schaltfläche " + d["0"] + " springen."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1623259957 = messageFormatterFn((function(  ) {
  return function(d) { return "Nächster Monat"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1381483915 = messageFormatterFn((function(  ) {
  return function(d) { return "Vorheriger Monat"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b11912108 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ist als Anreisedatum ausgewählt."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a545888903 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ist als Abreisedatum ausgewählt."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1831778448 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ist kein gültiges Anreisedatum."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b529559339 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ist kein gültiges Abreisedatum."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b13256644 = messageFormatterFn((function(  ) {
  return function(d) { return "Keine Verfügbarkeit am " + d["0"] + "."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b695860243 = messageFormatterFn((function(  ) {
  return function(d) { return "Heute"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b179183659 = messageFormatterFn((function(  ) {
  return function(d) { return "Ausgewähltes Check-in-Datum"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b551704562 = messageFormatterFn((function(  ) {
  return function(d) { return "Ausgewähltes Check-out-Datum"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1207689177 = messageFormatterFn((function(  ) {
  return function(d) { return "Ausgewähltes Datum"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1529093891 = messageFormatterFn((function(  ) {
  return function(d) { return "Von"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1551311484 = messageFormatterFn((function(  ) {
  return function(d) { return "Bis"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1058249021 = messageFormatterFn((function(  ) {
  return function(d) { return "Abbrechen, Kalender schließen ohne Änderungen zu speichern. Oder wähle aus den Tabellen unten einen Reisezeitraum aus."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1273084434 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " von " + d["1"]; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a1444950691 = messageFormatterFn((function(  ) {
  return function(d) { return "Drücke die Escape-Taste, um das Menü zu schließen."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a873786060 = messageFormatterFn((function(  ) {
  return function(d) { return "Drücke die Escape-Taste, um das Menü zu reduzieren."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1440251429 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte gib eine Zahl kleiner als " + d["0"] + " ein."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1977448442 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte gib eine Zahl größer als " + d["0"] + " ein."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.a716498701 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte gib eine Zahl zwischen " + d["0"] + " und " + d["1"] + " ein."; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1617675836 = messageFormatterFn((function(  ) {
  return function(d) { return "Erforderlich"; }
})(), Globalize("de-BE").pluralGenerator({}));
Globalize.b1526112806 = dateToPartsFormatterFn({"2":Globalize("de-BE").numberFormatter({"raw":"00"}),"4":Globalize("de-BE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.a1654308122 = dateToPartsFormatterFn({"2":Globalize("de-BE").numberFormatter({"raw":"00"}),"4":Globalize("de-BE").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.b754833427 = dateToPartsFormatterFn({"1":Globalize("de-BE").numberFormatter({"raw":"0"}),"4":Globalize("de-BE").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.b1877287385 = dateToPartsFormatterFn({"1":Globalize("de-BE").numberFormatter({"raw":"0"}),"4":Globalize("de-BE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.a1708449146 = dateToPartsFormatterFn({"2":Globalize("de-BE").numberFormatter({"raw":"00"}),"4":Globalize("de-BE").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.a1993837039 = dateToPartsFormatterFn({"1":Globalize("de-BE").numberFormatter({"raw":"0"}),"4":Globalize("de-BE").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.b788796134 = dateToPartsFormatterFn({"2":Globalize("de-BE").numberFormatter({"raw":"00"}),"4":Globalize("de-BE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.a1762590170 = dateToPartsFormatterFn({"2":Globalize("de-BE").numberFormatter({"raw":"00"}),"4":Globalize("de-BE").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.b2002882854 = dateToPartsFormatterFn({"2":Globalize("de-BE").numberFormatter({"raw":"00"}),"4":Globalize("de-BE").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.b996404819 = dateToPartsFormatterFn({"1":Globalize("de-BE").numberFormatter({"raw":"0"}),"4":Globalize("de-BE").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.a990029178 = dateToPartsFormatterFn({"2":Globalize("de-BE").numberFormatter({"raw":"00"}),"4":Globalize("de-BE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.a1220940357 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"S","mon":"M","tue":"D","wed":"M","thu":"D","fri":"F","sat":"S"}}}});
Globalize.b1900308326 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"Sonntag","mon":"Montag","tue":"Dienstag","wed":"Mittwoch","thu":"Donnerstag","fri":"Freitag","sat":"Samstag"}}}});
Globalize.a1141413530 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"Januar","2":"Februar","3":"März","4":"April","5":"Mai","6":"Juni","7":"Juli","8":"August","9":"September","10":"Oktober","11":"November","12":"Dezember"}}}});
Globalize.b1569471354 = dateToPartsFormatterFn({"1":Globalize("de-BE").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.b903912563 = dateToPartsFormatterFn({"1":Globalize("de-BE").numberFormatter({"raw":"0"}),"2":Globalize("de-BE").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.b1998369772 = dateToPartsFormatterFn({"1":Globalize("de-BE").numberFormatter({"raw":"0"})}, {"pattern":"d. MMM","timeSeparator":":","months":{"M":{"3":{"1":"Jan.","2":"Feb.","3":"März","4":"Apr.","5":"Mai","6":"Juni","7":"Juli","8":"Aug.","9":"Sept.","10":"Okt.","11":"Nov.","12":"Dez."}}}});
Globalize.b1839281931 = dateToPartsFormatterFn({"1":Globalize("de-BE").numberFormatter({"raw":"0"})}, {"pattern":"d. MMMM","timeSeparator":":","months":{"M":{"4":{"1":"Januar","2":"Februar","3":"März","4":"April","5":"Mai","6":"Juni","7":"Juli","8":"August","9":"September","10":"Oktober","11":"November","12":"Dezember"}}}});
Globalize.a873856096 = dateToPartsFormatterFn({"1":Globalize("de-BE").numberFormatter({"raw":"0"})}, {"pattern":"d. MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"Januar","2":"Februar","3":"März","4":"April","5":"Mai","6":"Juni","7":"Juli","8":"August","9":"September","10":"Oktober","11":"November","12":"Dezember"}}}});
Globalize.a1829243584 = dateToPartsFormatterFn({"1":Globalize("de-BE").numberFormatter({"raw":"0"})}, {"pattern":"MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"Januar","2":"Februar","3":"März","4":"April","5":"Mai","6":"Juni","7":"Juli","8":"August","9":"September","10":"Oktober","11":"November","12":"Dezember"}}}});
Globalize.a1829928777 = dateToPartsFormatterFn({"1":Globalize("de-BE").numberFormatter({"raw":"0"})}, {"pattern":"d. MMM y","timeSeparator":":","months":{"M":{"3":{"1":"Jan.","2":"Feb.","3":"März","4":"Apr.","5":"Mai","6":"Juni","7":"Juli","8":"Aug.","9":"Sept.","10":"Okt.","11":"Nov.","12":"Dez."}}}});
Globalize.b705086892 = dateToPartsFormatterFn({"1":Globalize("de-BE").numberFormatter({"raw":"0"})}, {"pattern":"EEEE, d. MMM","timeSeparator":":","days":{"E":{"4":{"sun":"Sonntag","mon":"Montag","tue":"Dienstag","wed":"Mittwoch","thu":"Donnerstag","fri":"Freitag","sat":"Samstag"}}},"months":{"M":{"3":{"1":"Jan.","2":"Feb.","3":"März","4":"Apr.","5":"Mai","6":"Juni","7":"Juli","8":"Aug.","9":"Sept.","10":"Okt.","11":"Nov.","12":"Dez."}}}});
Globalize.b1846670099 = dateToPartsFormatterFn({"1":Globalize("de-BE").numberFormatter({"raw":"0"})}, {"pattern":"E, d. MMM","timeSeparator":":","days":{"E":{"1":{"sun":"So.","mon":"Mo.","tue":"Di.","wed":"Mi.","thu":"Do.","fri":"Fr.","sat":"Sa."}}},"months":{"M":{"3":{"1":"Jan.","2":"Feb.","3":"März","4":"Apr.","5":"Mai","6":"Juni","7":"Juli","8":"Aug.","9":"Sept.","10":"Okt.","11":"Nov.","12":"Dez."}}}});
Globalize.b1147399055 = dateFormatterFn(Globalize("de-BE").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.a2033021873 = dateFormatterFn(Globalize("de-BE").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.a1060083780 = dateFormatterFn(Globalize("de-BE").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.b62370178 = dateFormatterFn(Globalize("de-BE").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.a2087162897 = dateFormatterFn(Globalize("de-BE").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.b486213050 = dateFormatterFn(Globalize("de-BE").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.b410082383 = dateFormatterFn(Globalize("de-BE").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.a2141303921 = dateFormatterFn(Globalize("de-BE").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.b1624169103 = dateFormatterFn(Globalize("de-BE").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.a818512388 = dateFormatterFn(Globalize("de-BE").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.a1368742929 = dateFormatterFn(Globalize("de-BE").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.a1069766990 = dateFormatterFn(Globalize("de-BE").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.a1558498417 = dateFormatterFn(Globalize("de-BE").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.a305252977 = dateFormatterFn(Globalize("de-BE").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.b986187761 = dateFormatterFn(Globalize("de-BE").dateToPartsFormatter({"raw":"d"}));
Globalize.b1295319644 = dateFormatterFn(Globalize("de-BE").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.b1570511203 = dateFormatterFn(Globalize("de-BE").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.b1460568180 = dateFormatterFn(Globalize("de-BE").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.b270919511 = dateFormatterFn(Globalize("de-BE").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.b2087009961 = dateFormatterFn(Globalize("de-BE").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.b2086324768 = dateFormatterFn(Globalize("de-BE").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.b1322817443 = dateFormatterFn(Globalize("de-BE").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.b1467956348 = dateFormatterFn(Globalize("de-BE").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.a466662688 = dateParserFn(Globalize("de-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.b647883680 = dateParserFn(Globalize("de-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.a270702771 = dateParserFn(Globalize("de-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b851751187 = dateParserFn(Globalize("de-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.b593742656 = dateParserFn(Globalize("de-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.b1275594059 = dateParserFn(Globalize("de-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.a1203979360 = dateParserFn(Globalize("de-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.b539601632 = dateParserFn(Globalize("de-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.b10107360 = dateParserFn(Globalize("de-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.a29131379 = dateParserFn(Globalize("de-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.b1312162624 = dateParserFn(Globalize("de-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.b1419065537 = dateParserFn(Globalize("de-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^S/],["mon",/^M/],["tue",/^D/],["wed",/^M/],["thu",/^D/],["fri",/^F/],["sat",/^S/]]});
Globalize.a646929504 = dateParserFn(Globalize("de-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["thu",/^Donnerstag/],["tue",/^Dienstag/],["wed",/^Mittwoch/],["sun",/^Sonntag/],["fri",/^Freitag/],["sat",/^Samstag/],["mon",/^Montag/]]});
Globalize.b606315936 = dateParserFn(Globalize("de-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^September/],["11",/^November/],["12",/^Dezember/],["2",/^Februar/],["10",/^Oktober/],["1",/^Januar/],["8",/^August/],["4",/^April/],["3",/^März/],["6",/^Juni/],["7",/^Juli/],["5",/^Mai/]]});
Globalize.a1750992512 = dateParserFn(Globalize("de-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.b1139716653 = dateParserFn(Globalize("de-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b271518706 = dateParserFn(Globalize("de-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["9",/^Sept\./],["1",/^Jan\./],["2",/^Feb\./],["4",/^Apr\./],["8",/^Aug\./],["10",/^Okt\./],["11",/^Nov\./],["12",/^Dez\./],["3",/^März/],["6",/^Juni/],["7",/^Juli/],["5",/^Mai/]]});
Globalize.a153493563 = dateParserFn(Globalize("de-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^September/],["11",/^November/],["12",/^Dezember/],["2",/^Februar/],["10",/^Oktober/],["1",/^Januar/],["8",/^August/],["4",/^April/],["3",/^März/],["6",/^Juni/],["7",/^Juli/],["5",/^Mai/]]});
Globalize.b1774613030 = dateParserFn(Globalize("de-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^September/],["11",/^November/],["12",/^Dezember/],["2",/^Februar/],["10",/^Oktober/],["1",/^Januar/],["8",/^August/],["4",/^April/],["3",/^März/],["6",/^Juni/],["7",/^Juli/],["5",/^Mai/]]});
Globalize.b472948218 = dateParserFn(Globalize("de-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^September/],["11",/^November/],["12",/^Dezember/],["2",/^Februar/],["10",/^Oktober/],["1",/^Januar/],["8",/^August/],["4",/^April/],["3",/^März/],["6",/^Juni/],["7",/^Juli/],["5",/^Mai/]]});
Globalize.b472263025 = dateParserFn(Globalize("de-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMM y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["9",/^Sept\./],["1",/^Jan\./],["2",/^Feb\./],["4",/^Apr\./],["8",/^Aug\./],["10",/^Okt\./],["11",/^Nov\./],["12",/^Dez\./],["3",/^März/],["6",/^Juni/],["7",/^Juli/],["5",/^Mai/]]});
Globalize.a1031689550 = dateParserFn(Globalize("de-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE, d. MMM","digitsRe":/\d/,"gregorian/days/format/wide":[["thu",/^Donnerstag/],["tue",/^Dienstag/],["wed",/^Mittwoch/],["sun",/^Sonntag/],["fri",/^Freitag/],["sat",/^Samstag/],["mon",/^Montag/]],"gregorian/months/format/abbreviated":[["9",/^Sept\./],["1",/^Jan\./],["2",/^Feb\./],["4",/^Apr\./],["8",/^Aug\./],["10",/^Okt\./],["11",/^Nov\./],["12",/^Dez\./],["3",/^März/],["6",/^Juni/],["7",/^Juli/],["5",/^Mai/]]});
Globalize.a146105395 = dateParserFn(Globalize("de-BE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"E, d. MMM","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["sun",/^So\./],["mon",/^Mo\./],["tue",/^Di\./],["wed",/^Mi\./],["thu",/^Do\./],["fri",/^Fr\./],["sat",/^Sa\./]],"gregorian/months/format/abbreviated":[["9",/^Sept\./],["1",/^Jan\./],["2",/^Feb\./],["4",/^Apr\./],["8",/^Aug\./],["10",/^Okt\./],["11",/^Nov\./],["12",/^Dez\./],["3",/^März/],["6",/^Juni/],["7",/^Juli/],["5",/^Mai/]]});
module.exports = Globalize;
